import { render, staticRenderFns } from "./ProductAndAreaOutput.vue?vue&type=template&id=0a813fb0&"
import script from "./ProductAndAreaOutput.vue?vue&type=script&lang=js&"
export * from "./ProductAndAreaOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/ProductAndAreaOutput.vue
// module id = null
// module chunks = 